import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/constants/constants';
import { CartService } from 'src/app/services/dhukan/cart.service';

import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { CustomerinfoComponent } from '../customerinfo/customerinfo.component';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-cartslider',
  templateUrl: './cartslider.component.html',
  styleUrls: ['./cartslider.component.css']
})
export class CartsliderComponent implements OnInit {


  cartBO: any = {};
  cartColl: any = [];
  cartView: any = {};


  customerBO: any = {};
  customerView: any = {};

  @Input() companyid: any = null

  @Input() remarks: any = ""

  // @Input() productBO: any = {}

  // @Input() variationColl: any = []

  selectvariation: any = ""


  isshowbackdrop: boolean = false

  @Output() emitData = new EventEmitter();

  @Output() cartchangeData = new EventEmitter();

  _routerCartSub = Subscription.EMPTY;
  _routerCustomerSub = Subscription.EMPTY;

  dinetype: String = ""

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private cartservice: CartService, private activeModal: NgbActiveModal, private loginService: LoginDataService) {


    if (AppSettings.appname === "QRTAKEAWAY") {
      this.dinetype = "TAKEAWAY";
    }
    else if (AppSettings.appname === "QRDINEIN") {
      this.dinetype = "DINEIN";
    }
    else if (AppSettings.appname === "QRDELIVERY") {
      this.dinetype = "DELIVERY";
    }


    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.cartView = this.cartservice.cartView;
    this._routerCartSub = this.cartservice.servicecartChange.subscribe((value) => {
      this.cartView = value
      if (this.cartView.cartmain) {
        this.cartBO = this.cartView.cartmain
      }
      if (this.cartView.cartdetails) {
        this.cartColl = this.cartView.cartdetails
      }

    });

    this._routerCustomerSub = this.loginService.servicecustomerChange.subscribe((value) => {
      this.customerView = value
      if (this.customerView.customermain) {
        this.customerBO = this.customerView.customermain
      }
    });


  }


  ngOnInit() {

    this.cartView = this.cartservice.cartView;
    if (this.cartView.cartmain) {
      this.cartBO = this.cartView.cartmain
    }
    if (this.cartView.cartdetails) {
      this.cartColl = this.cartView.cartdetails
    }
    this.cartView = this.cartservice.cartView;


    this.customerView = this.loginService.customerView
    if (this.customerView.customermain) {
      this.customerBO = this.customerView.customermain
    }

  }

  ngOnDestroy(): void {
    if (this._routerCartSub !== undefined) {
      this._routerCartSub.unsubscribe();
    }

    if (this._routerCustomerSub !== undefined) {
      this._routerCustomerSub.unsubscribe();
    }


  }

  fnPlaceOrderBtnClick() {
    try {

      if (this.dinetype === "DELIVERY") {
        if (this.customerBO.partyid > 0) {
          this.fnShowCustomerInfo();
        }
        else {
          this.fnSignupLoginBtnClick("LOGIN")
        }
      }
      else {
        this.fnShowCustomerInfo();
       // this.fnSignupLoginBtnClick('LOGIN');
      }




    } catch (ex) {
      this.isshowbackdrop = false;
    }

  }


  fnShowCustomerInfo() {
    this.isshowbackdrop = true;
    
    const modalRef = this.productFindService.open(CustomerinfoComponent, { 
        size: <any>'m', 
        backdrop: 'static',
        centered: true 
    });


    this.activeModal.close(); 

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        this.isshowbackdrop = false;
        receivedEntry.remarks = this.remarks;
        
        this.emitData.emit(receivedEntry);
    });

    modalRef.result.then(() => {
        this.isshowbackdrop = false;
    }, () => {
        this.isshowbackdrop = false;
    });
}

  public fnIncreseBtnClick(dbo) {

    var data = {
      action: 'ADD',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }

  public fnDecreseBtnClick(dbo) {

    var data = {
      action: 'DECRESE',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }

  public fnRemoveBtnClick(dbo) {

    var data = {
      action: 'REMOVE',
      abo: dbo
    }
    this.cartchangeData.emit(data)
  }


  public decline() {


    this.activeModal.close(false);
  }





  //LOGIn


  //Signup login
  fnSignupLoginBtnClick(type) {
    this.isshowbackdrop = true
    const modalRef = this.productFindService.open(LoginComponent, {
      size: 'lg', backdropClass: 'light-blue-backdrop', centered: true, backdrop: 'static',
      keyboard: false
    });
    if (type === "LOGIN") {
      modalRef.componentInstance.islogin = true;
    } else if (type === "SIGNUP") {
      modalRef.componentInstance.issignup = true;
    }
    modalRef.componentInstance.companyid = this.companyid
    modalRef.componentInstance.emitData.subscribe((loginEntry) => {
      this.isshowbackdrop = false;
      this.fnGetLoginCustomer(loginEntry)

    });

    modalRef.result.then(() => {
      this.isshowbackdrop = false;
    }, () => {
      this.isshowbackdrop = false;
    })

  }
  async fnGetLoginCustomer(data) {


    localStorage.setItem('adtoken', JSON.stringify(data));
    await this.loginService.fnGetCustomerList();  
    await this.fnSetCartLoginCustomer();
    if (this.dinetype === "DELIVERY") {
      this.fnShowCustomerInfo();
    }
    else {
      var sdata = {
        'customername': this.customerBO.partyname,
        'mobile': this.customerBO.mobile,
        'remarks': this.remarks,
      }
      this.emitData.emit(sdata);
      this.activeModal.close(false);
    }



  }
  async fnSetCartLoginCustomer() {
    var data = {
      'customerid': 0,
      'sessionid': ''
    }
    await this.loginService.fnSetCartCustomerLogin(data)
      .then(
        (res) => {
          if (res.json().status == 200) {
            this.cartservice.fnGetCartList();
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }

        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })

  }

  fnShowErrorMsg(ex) {
    console.log(ex)
  }

}
